import { render, staticRenderFns } from "./NoticeAlerts.vue?vue&type=template&id=d8d1797a&scoped=true"
import script from "./NoticeAlerts.vue?vue&type=script&lang=js"
export * from "./NoticeAlerts.vue?vue&type=script&lang=js"
import style0 from "./NoticeAlerts.vue?vue&type=style&index=0&id=d8d1797a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d1797a",
  null
  
)

export default component.exports